import type { RefObject } from 'react';

import { useEffect } from 'react';

/**
 * Hook that alerts clicks outside of the passed ref
 */
const useClickOutside = <T extends HTMLElement>(
  ref: RefObject<T>,
  handleClickOutside: () => void
) => {
  /**
   * Handle passed click outside
   */
  const handleClick = (event: MouseEvent) => {
    if (
      ref.current &&
      event.target &&
      !ref.current.contains(event.target as Node)
    ) {
      handleClickOutside();
    }
  };

  useEffect(() => {
    // Bind the event listener
    document.addEventListener('mouseup', handleClick);

    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mouseup', handleClick);
    };
  });
};

export { useClickOutside };
